import { FaqProps } from "@ft/components/common/Faq";

const asciiTpStringFaqData: FaqProps[] = [
  {
    question: "What is an ASCII to Text Converter?",
    ans: "An ASCII to Text Converter decodes ASCII-encoded characters into their corresponding textual representation.",
  },
  {
    question: "How do I use the ASCII decoder?",
    ans: "Just enter your ASCII code into the converter, and it will instantly show the string.",
  },
  {
    question: "Why do I need to convert ASCII codes to text?",
    ans: "Converting ASCII to plaintext helps you understand coded messages or see readable text instead of numbers.",
  },
  {
    question: "Is there a cost to use this ASCII translator?",
    ans: "No, this tool is completely free to use for anyone.",
  },
  {
    question: "Can I convert multiple ASCII codes to text at once?",
    ans: "Yes, you can enter multiple ASCII codes, and the converter will show all text results together.",
  },
  {
    question: "What types of ASCII codes does this tool support?",
    ans: "This converter supports both standard ASCII codes (0-127) and extended ASCII codes (128-255).",
  },
  {
    question: "Can I use this ASCII decoder on my mobile device?",
    ans: "Yes, our ASCII decoder is mobile-friendly and works on any device.",
  },
  {
    question:
      "Can this tool convert ASCII codes back to symbols or special characters?",
    ans: "Yes, it can convert ASCII codes to all readable characters, symbols, or special characters.",
  },
  {
    question: "Is this ASCII to string Converter safe?",
    ans: "Yes, our converter is secure and does not store any data entered by users.",
  },
];

export default asciiTpStringFaqData;
